import { Component, Input } from '@angular/core';

@Component({
    selector: 'jhi-disability-question',
    templateUrl: 'disability-question.component.html'
})
export class DisabilityQuestionComponent {

    @Input() readonly: boolean;
    @Input() disabled: boolean;
    @Input() key: string;
    @Input() resultObject: Object;

    get label() {
        return 'tmmsaisineApp.saisine.disabilityQuestions.' + this.key;
    }

    get name() {
        return this.key.replace(/\./g, '');
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/disability-question/disability-question.component.ts